/**
 * Auth slice
 */

import { createAction, createSlice } from '@reduxjs/toolkit';
import { User } from './types';

const initialState = {
  user: null as User | null,
  token: null as string | null,
  isAuthenticated: false,
  loading: false,
  error: null as string | null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthToken(state, action) {
      state.token = action.payload;
      if (action.payload) {
        localStorage.setItem('authToken', action.payload);
      } else {
        localStorage.removeItem('authToken');
      }
    },
    setUser(state, action) {
      state.user = action.payload;
      state.isAuthenticated = !!action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setAuthError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    clearAuthError(state) {
      state.error = null;
    },
    logout(state) {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.error = null;
      localStorage.removeItem('authToken');
    },
  },
});

// Reducer
export const authReducer = authSlice.reducer;

// Actions
export const {
  setAuthToken,
  setUser,
  setLoading: setAuthLoading,
  setAuthError,
  clearAuthError,
  logout,
} = authSlice.actions;

// Async Actions
export const login = createAction<{ email: string; password: string }>(
  'AUTH/LOGIN'
);
export const signup = createAction<{
  username: string;
  email: string;
  password: string;
}>('AUTH/SIGNUP');
export const getProfile = createAction('AUTH/GET_PROFILE');
export const updateProfile = createAction<any>('AUTH/UPDATE_PROFILE');

